module.exports = __webpack_public_path__ + "static/img/10.c923a20.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/10.png
// module id = erpH
// module chunks = 0